export enum LogLevel
{
	INFO = "info",
	WARN = "warn",
	ERROR = "error",
}
